import { modifyUrlForProxy } from 'src/utils/helpers'
import { BadgeName } from 'src/app/types'
// import badges from './badges'

export const CANVAS_FONT_FAMILY =
  "SF, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
export const CANVAS_PADDING = 16
export const CANVAS_FONT_SIZE = 50
export const MIN_PERSISTENCE_CLIENT_VERSION = 51160000
export const HOST_SESSIONS_LIST_LENGTH = 10
export const DEFAULT_BADGES: BadgeName[] = [
  'trophy',
  'medal',
  'star',
  'check-mark-button',
  'ribbon',
]
// kept here or else circular dependency
// export type BadgeName = keyof typeof BADGE_MAP

// names come from this website: https://unicode.org/emoji/charts/full-emoji-list.html
export const BADGE_MAP = {
  trophy: '🏆',
  medal: '🏅',
  star: '⭐',
  'check-mark-button': '✅',
  ribbon: '🎗️',
} as const

export const BADGE_TO_NAME_MAP = {
  '🏆': 'trophy',
  '🏅': 'medal',
  '⭐': 'star',
  '✅': 'check-mark-button',
  '🎗️': 'ribbon',
} as const

export const BADGE_SVG_URL_MAP = {
  trophy: modifyUrlForProxy('/badges/trophy.svg'),
  medal: modifyUrlForProxy('/badges/medal.svg'),
  star: modifyUrlForProxy('/badges/star.svg'),
  'check-mark-button': modifyUrlForProxy('/badges/check.svg'),
  ribbon: modifyUrlForProxy('/badges/ribbon.svg'),
} as const

// super hack - pre-loads svgs into browser cache
Object.values(BADGE_SVG_URL_MAP).forEach((svgUrl) => {
  const myImage = new Image()
  myImage.src = svgUrl
})
